import { render, staticRenderFns } from "./AddressFieldEditor.vue?vue&type=template&id=428a81af&"
import script from "./AddressFieldEditor.vue?vue&type=script&lang=js&"
export * from "./AddressFieldEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QSelect,QInput} from 'quasar'
component.options.components = Object.assign({QItem,QSelect,QInput}, component.options.components || {})
